import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [['MC', 'María C.', 'Buenos Aires', 'Pasamos 18 días sin ningún episodio. Lloré de alegría.'], ['LP', 'Laura P.', 'Córdoba', 'El sistema me ayudó a detectar que el gluten era un gatillo clarísimo.'], ['SR', 'Susana R.', 'Rosario', 'Llegué al neurólogo con todo organizado. Me dijo que era la madre más preparada que había visto.']] as const;
const extended = [['María C.', 'Buenos Aires', '“Mi hijo llevaba 3 años con crisis semanales. Al mes pasamos 18 días sin ningún episodio. Fue la primera vez que dormí tranquila.”'], ['Laura P.', 'Córdoba', '“El radar de gatillos me mostró que el gluten era un disparador clarísimo. Algo que 4 neurólogos nunca mencionaron.”'], ['Susana R.', 'Rosario', '“Por primera vez llegué a la consulta con todo organizado. El neurólogo me dijo que era la madre más preparada que había visto.”'], ['Claudia M.', 'Mendoza', '“Soy enfermera y empecé con escepticismo. Al día 8 los cambios fueron tan claros que se lo recomendé a otras madres del grupo.”']] as const;
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-169" data-mp="1lcqwq57dbr4w">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-170" data-mp="1q9hd6tn34oqu" />)}
    </div>;
}
export function StatsAndProof() {
  const stats = [['+180', 'familias aplicando el protocolo'], ['5', 'Volúmenes completos'], ['5', 'Bonos incluidos'], ['4.9/5', 'calificación']];
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-171" data-mp="249iol30z7ekk">
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10" data-id="element-172" data-mp="292l9ynvlnhpo">
          {stats.map(([value, label]) => <div key={label} className="text-center" data-id="element-173" data-mp="2dzbqtdf8ahc5">
              <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-174" data-mp="2i2i2j0l410q0">{value}</p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-175" data-mp="2i0dss20j57ht">{label}</p>
            </div>)}
        </div>
      </section>

      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-176" data-mp="mzv7prxkcoii">
        <div className="mx-auto grid max-w-6xl gap-5 md:grid-cols-3" data-id="element-177" data-mp="ixqbqmjn7fsp">
          {testimonials.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-178" data-mp="wpn3uqlb9pp3" data-mpi={index}>
              <div className="flex items-center gap-3" data-id="element-179" data-mp="11noimzbpf2ur">
                <div className="grid h-11 w-11 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-180" data-mp="1fnzekgrvf7ms">{initials}</div>
                <div data-id="element-181" data-mp="1amjvgu997b71">
                  <h3 className="font-bold" data-id="element-182" data-mp="3heubjbxtdcv3">{name}</h3>
                  <p className="text-sm text-slate-400" data-id="element-183" data-mp="3hfm56h7up0iq">{place}</p>
                </div>
              </div>
              <div className="mt-5" data-id="element-184" data-mp="3chu4axp8a42e"><Stars data-id="element-185" data-mp="3cidl2b356meu" /></div>
              <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-186" data-mp="1rxgqg7rmxwpn">“{quote}”</p>
            </motion.article>)}
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-187" data-mp="1j66mrnmwgk78">
      <div className="mx-auto max-w-5xl" data-id="element-188" data-mp="1n709idolvsyj">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-189" data-mp="1n5xi84ndfoi3">
          LO QUE DICEN LAS MADRES QUE YA LO TIENEN
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-190" data-mp="1e73hq36x6dz9">
          {extended.map(([name, place, quote]) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-191" data-mp="107askcb1k5te">
              <Stars data-id="element-192" data-mp="148e8szx043v5" />
              <p className="mt-2 font-bold" data-id="element-193" data-mp="147uppfvm79fj">{name} <span className="font-normal text-slate-400" data-id="element-194" data-mp="148wc2gi2zick">· {place}</span></p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-195" data-mp="2ulv8ycsbxf6z">{quote}</p>
            </article>)}
        </div>
      </div>
    </section>;
}